import DrumPad from "./DrumPadContainer.js"
export default DrumPad;